import(/* webpackMode: "eager" */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/(alfamall)/account/forgotpassword/page.jsx");
